export default {
  translation: {
    applyNow: {
      mainCTA: "Aplique Ahora",
      floifyVerifyVoa: {
        title: "Conecte sus cuentas para una aprobación más rápida",
        subtitle:
          "Agregue de forma segura sus cuentas de cheques y ahorros, y nosotros reuniremos la información y los documentos necesarios.",
        whyConnect: "¿Por qué debería conectar mis cuentas?",
        connectButton: "Conectar cuentas",
        connecting: "Conectando...",
        enterManually: "Ingresar los datos de la cuenta manualmente",
        mastercardSecurity:
          "Conexión segura a través de Mastercard: funciona con todos los principales bancos de EE. UU. Nunca vemos ni almacenamos su contraseña.",
        lenderContinue: "Continuar",
      },
      ocrAutofill: {
        continueButton: "Continuar",
        savingButton: "Guardando",
        connectOverlayModal: {
          title: "Conecte sus cuentas",
          connectingTitle: "Preparando su conexión",
          connectingSubtitle: "Esto solo tomará un momento.",
          activeSubtitle:
            "Se ha abierto una nueva ventana o pestaña donde puede conectar sus cuentas bancarias. Regrese aquí cuando haya terminado para continuar.",
          processingTitle: "Reuniendo sus cuentas",
          processingSubtitle: "Esto solo debería tomar unos segundos.",
          closeButton: "Cerrar",
          cancelButton: "Cancelar",
        },
        confirmDetailsModal: {
          title: "Confirme algunos datos primero",
          subtitle:
            "Usaremos esta información para verificar su identidad de forma segura y abrir la ventana para conectar sus cuentas bancarias.",
          dateOfBirthLabel: "Fecha de nacimiento",
          currentAddressLabel: "Dirección actual",
          streetPlaceholder: "Calle",
          unitPlaceholder: "Apto., suite (opcional)",
          cityPlaceholder: "Ciudad",
          statePlaceholder: "Estado",
          postalCodePlaceholder: "Código postal",
          notNow: "Ahora no",
        },
        whyConnectModal: {
          title: "¿Por qué debería conectar mis cuentas bancarias?",
          gotIt: "Entendido",
          skipPaperworkHeading: "Evite el papeleo",
          skipPaperworkSubheading:
            "Obtendremos los datos de su cuenta y su historial de transacciones recientes por usted.",
          credentialsHeading: "Sus credenciales permanecen privadas",
          credentialsSubheading: "Nunca vemos ni almacenamos su contraseña.",
          fasterApprovalHeading: "Aprobación más rápida",
          fasterApprovalSubheading:
            "Conectar sus cuentas acelera el proceso de verificación.",
        },
        loanPurposeScreen: {
          title: "¿Qué tipo de préstamo está solicitando?",
        },
        inputValidation: {
          date: {
            invalidGeneric: "Fecha inválida",
            requireDateOfBirth: "Ingrese una fecha de nacimiento",
            requireLessThan100Years: "La fecha debe ser más reciente",
            requireNotFuture: "La fecha no puede ser en el futuro",
          },
          string: {
            invalidPostalCode: "Código postal inválido",
            invalidState: "Ingrese un estado válido",
            maxCount: "No puede exceder {{count}} caracteres",
            requireCity: "Ingrese una ciudad",
            requireGeneric: "Este campo es obligatorio",
            requirePostalCode: "Ingrese un código postal",
            requireState: "Ingrese un estado",
            requireStreet: "Ingrese una dirección",
          },
        },
      },
      ssoLoginCard: {
        cardHeading: "Iniciar una solicitud de préstamo",
        cardSubheading:
          "¿Comenzando el proceso de solicitud de préstamo? ¡Estás en el lugar correcto! Comienza creando una cuenta.",
        confirmEmailInputLabel: "Confirmación de Correo Electrónico",
        continueButton: "Continuar con email",
        emailInputLabel: "Correo Electrónico",
        passwordInputLabel: "Contraseña",
        passwordVisibilityHide: "Ocultar",
        passwordVisibilityShow: "Mostrar",
      },
    },
    auth: {
      back: "Atrás",
      continueWithProvider: "Continúe con {{provider}}",
      emailNotFoundLink: "iniciar sesión",
      emailNotFoundPrefix:
        "¡No encontramos ese correo electrónico! Cree una cuenta nueva aquí o intente",
      emailNotFoundSuffix: "de nuevo.",
      forgotPasswordSuggestive: "¿No recuerda su contraseña?",
      goBack: "Regresar",
      greetReturningUser: "Bienvenido de nuevo",
      logInOrCreateAccount: "Inicie sesión o cree una cuenta",
      logInWithMicrosoft: "Inicie sesión con Microsoft",
      loginButton: "Inicia sesión",
      loginCredentialsMismatch:
        "La combinación de correo electrónico y contraseña que ingresó no coincide con nuestros registros",
      loginPromptDirect: "Inicia sesión con su cuenta.",
      loginPromptSuggestive: "¿Tiene una cuenta?",
      microsoftLogoAlt: "Logotipo de Microsoft",
      next: "Siguiente",
      noAccountSuggestive: "¿No tiene una cuenta?",
      noPassword: {
        accountAlreadyCreated: "La cuenta ya fue creada",
        accountCreatedButtonSuffix: "a continuación.",
        accountCreatedPrefix: "{{name}} ya creó una cuenta para",
        accountCreatedResendMiddle:
          ". Revise su correo electrónico para encontrar el enlace de configuración de contraseña, o haga clic en el botón",
        accountCreatedResendSuffix: "a continuación para crear su contraseña.",
        accountCreatedSetupLinkMiddle:
          ". Revise su correo electrónico para encontrar el enlace de configuración de contraseña. Si no lo ve, haga clic en el botón",
        applicationInProgress: "Solicitud en curso",
        applicationInProgressMiddle:
          ", ya tiene una solicitud en curso. Revise su correo electrónico para encontrar el enlace de la solicitud, o haga clic en",
        applicationInProgressPrefix: "El correo electrónico que proporcionó,",
        applicationInProgressSuffix:
          "a continuación para acceder a su solicitud.",
        applicationSubmitted:
          "¡Envió su solicitud de préstamo correctamente! Le enviaremos un correo electrónico en cuanto esté lista.",
        applicationUnderReview: "Solicitud en revisión",
        changeEmailAddress: "Cambiar correo electrónico",
        checkYourEmail: "Revise su correo electrónico",
        contactSupport: "Contactar soporte",
        helpOnItsWay: "¡La ayuda está en camino!",
        loanOfficerWillContactMiddle:
          ". Si este correo electrónico es incorrecto, haga clic en",
        loanOfficerWillContactPrefix:
          "Su oficial de préstamos, {{name}}, se comunicará con usted en breve al",
        loanOfficerWillContactSuffix: "a continuación.",
        resendLink: "Reenviar enlace",
        resentApplicationPrefix:
          "Acabamos de reenviar un correo electrónico con el enlace a su solicitud a",
        resentMiddle:
          ". Si no lo ve, revise su carpeta de correo no deseado o haga clic en",
        resentPrefix: "Acabamos de reenviar el correo electrónico a",
        resentSuffix: "a continuación para obtener ayuda.",
        sentPrefix: "Acabamos de enviar un correo electrónico a",
        sentSuffix:
          ". Revise su bandeja de entrada y haga clic en el enlace de verificación para comenzar su solicitud.",
        sentenceEnd: ".",
        verifyHeading: "Verifique su correo electrónico",
      },
      or: "O",
      passwordInputAria: "Contraseña",
      passwordRequirements: {
        characters: "caracteres",
        heading: "La contraseña debe contener al menos",
        lowerCaseLetters: "letra minúscula",
        numbers: "número",
        specialCharacters: "carácter especial (!, #, %, etc.)",
        upperCaseLetters: "letra mayúscula",
      },
      resetPasswordLink: "restablecer su contraseña",
      resetPasswordPrefix: "Puede",
      resetPasswordSuffix: "o intentar de nuevo.",
      setUpAccountHeading: "¡Bienvenido! Vamos a configurar su cuenta",
      ssoProviderLogoAlt: "Logotipo de {{provider}}",
      termsAgreementCheckboxPrefix: "Acepto los",
      termsAgreementLink: "Términos de Uso y la Política de Privacidad",
      termsAgreementPrefix: "Al iniciar sesión, usted acepta los",
      termsCheckboxAria: "Términos y condiciones de Floify",
    },
    landingPage: {
      calculators: {
        common: {
          accessCalculators: "Acceda a las calculadoras",
          currentTerm: "Plazo actual",
          hideAdvancedOptions: "Ocultar opciones avanzadas",
          perMonth: "/mes",
          perMonthAbbr: "mes",
          perMonthTag: "/ mes",
          perYearAbbr: "año",
          resultsBreakdown: "Desglose de resultados",
          showAdvancedOptions: "Mostrar opciones avanzadas",
          showPaymentBreakdown: "Ver desglose del pago",
          term: "Plazo",
          yourPayment: "Su pago",
        },
        debtToIncome: {
          inputs: {
            alimonyChildSupport: "Pensión alimenticia / manutención",
            annualIncome: "Ingreso anual",
            carLoanPayments: "Pagos de préstamo de auto",
            minCreditCardPayments: "Pago mín. de tarjetas de crédito",
            mortgagePayment: "Pago hipotecario",
            otherLoanOrDebtPayments: "Otros pagos de préstamos o deudas",
            secondaryHomeExpenses: "Gastos de segunda vivienda",
            studentLoanPayments: "Pagos de préstamo estudiantil",
          },
          legend: {
            debts: "Deudas",
            mortgage: "Hipoteca",
            remaining: "Restante",
          },
          ratioLabel: "Su relación deuda-ingreso es",
          series: {
            monthlyDebts: "Deudas mensuales",
            mortgagePayment: "Pago hipotecario",
            remainingIncome: "Ingreso mensual restante",
          },
          showRatioBreakdown: "Ver desglose de la relación",
          title: "Calculadora de deuda-ingreso",
        },
        mortgage: {
          inputs: {
            downPayment: "Pago inicial",
            downPaymentPercent: "Porcentaje del pago inicial",
            homePrice: "Precio de la vivienda",
            homeownersAssociation: "Asociación de propietarios",
            homeownersInsurance: "Seguro de vivienda",
            interestRate: "Tasa de interés",
            loanProgram: "Programa de préstamo",
            propertyTax: "Impuesto predial",
          },
          loanProgram: {
            fifteenYearFixed: "Fija a 15 años",
            thirtyYearFixed: "Fija a 30 años",
          },
          results: {
            homeownersAssociation: "Asociación de propietarios",
            insurance: "Seguro",
            principalAndInterest: "Principal + intereses",
            taxes: "Impuestos",
          },
          title: "Calculadora de hipoteca",
        },
        rates: {
          amortization: {
            arm: "tasa ajustable",
            fixed: "tasa fija",
          },
          aprValue: "{{value}}% APR",
          creditScore: {
            exceptional: "800+ (Excepcional)",
            fair: "580-669 (Regular)",
            good: "670-739 (Bueno)",
            lessThan580: "Menos de 580",
            veryGood: "740-799 (Muy bueno)",
          },
          inputs: {
            creditScore: "Puntaje de crédito",
            downPayment: "Pago inicial",
            downPaymentPercent: "Porcentaje del pago inicial",
            firstTimeBuyer: "Comprador por primera vez",
            homePrice: "Precio de la propiedad",
            homeValue: "Valor de la vivienda",
            homeownersAssociation: "Asociación de propietarios",
            homeownersInsurance: "Seguro de vivienda",
            loanBalance: "Saldo del préstamo",
            loanPurpose: "Propósito del préstamo",
            loanTerm: "Plazo del préstamo",
            militaryVeteran: "Militar / veterano",
            propertyCounty: "Condado de la propiedad",
            propertyState: "Estado de la propiedad",
            propertyTax: "Impuesto predial",
            propertyTaxPercent: "Porcentaje del impuesto predial",
            propertyType: "Tipo de propiedad",
            propertyUse: "Uso de la propiedad",
            selfEmployed: "Trabaja por cuenta propia",
          },
          intro:
            "Compare opciones de préstamo con las tasas hipotecarias de hoy. Luego haga clic en <i>Aplique Ahora</i> para recibir su cotización personalizada.",
          loanPurpose: {
            purchase: "Comprar",
            refinance: "Refinanciar",
          },
          loanTerm: {
            years: "{{count}} años",
          },
          locationNotChosen:
            "Seleccione el estado y el condado de la propiedad que desea comprar para ver las mejores tasas hipotecarias de hoy.",
          noRatesFound:
            "No encontramos tasas para los valores que ingresó. Intente ajustar sus criterios o comience su solicitud.",
          pmiDisclaimer:
            "* El pago mensual no incluye el seguro hipotecario privado.",
          propertyType: {
            condo: "Condominio",
            cooperative: "Cooperativa",
            manufactured: "Móvil o prefabricada",
            modular: "Modular",
            singleFamily: "Unifamiliar",
            townhouse: "Casa adosada",
          },
          propertyUse: {
            investmentProperty: "Propiedad de inversión",
            primaryResidence: "Residencia principal",
            secondHome: "Segunda vivienda",
          },
          rateValue: "{{value}}% de tasa",
          showFewerRates: "Ver menos tasas",
          showMoreRates: "Ver más tasas",
          termDescription: "{{amortization}} a {{count}} años",
          title: "Tasas",
        },
        refinance: {
          breakevenIn: "Punto de equilibrio en",
          breakevenMonths_one: "{{count}} mes",
          breakevenMonths_other: "{{count}} meses",
          chart: {
            costs: "Costos",
            yearsAbbr_one: "{{count}} año",
            yearsAbbr_other: "{{count}} años",
          },
          couldCost: "Refinanciar podría costarle",
          couldSave: "Refinanciar podría ahorrarle",
          currentHeading: "ACTUAL",
          hideDetails: "Ocultar detalles",
          inputs: {
            cashOut: "Retiro de efectivo",
            currentTermOfLoan: "Plazo actual del préstamo",
            interestRate: "Tasa de interés",
            loanAmount: "Monto del préstamo",
            newLoanAmount: "Monto del nuevo préstamo",
            newTerm: "Nuevo plazo",
            originationYear: "Año de originación",
            refinanceFees: "Costos de refinanciamiento",
            rollFees: "¿Incluir los costos en el nuevo préstamo?",
          },
          lifetimeCost: "Costo total adicional del nuevo préstamo",
          lifetimeSavings: "Ahorro total del nuevo préstamo",
          newHeading: "NUEVO",
          newMonthlyPayment: "Con un nuevo pago mensual de",
          notAvailable: "N/D",
          savingsAfterYears: "Ahorros después de {{count}} años",
          showDetails: "Ver más detalles",
          termYears: "{{count}} años",
          title: "Calculadora de refinanciamiento",
          tooltips: {
            cashOut:
              "La cantidad de plusvalía de su propiedad a la que desea acceder en efectivo. Suele usarse para consolidar deudas, mejoras a la vivienda o cualquier otro fin.",
            originationYear: "El año en que obtuvo el préstamo.",
          },
        },
        tabs: {
          debtToIncome: "Deuda-Ingreso",
          mortgage: "Hipoteca",
          rates: "Tasas",
          refinance: "Refinanciamiento",
        },
      },
      footer: {
        help: "Ayuda",
        privacyAndTerms: "Privacidad y Términos",
      },
      head: {
        title: "Aplique Ahora",
      },
      header: {
        logoAlt: "Logotipo del prestamista",
      },
      leadGen: {
        countyRequired: "El condado es obligatorio",
        emailAddress: "Correo electrónico",
        firstName: "Nombre",
        firstNameRequired: "El nombre es obligatorio",
        heading: "Cuéntenos un poco sobre usted",
        lastName: "Apellido",
        lastNameRequired: "El apellido es obligatorio",
        marketingConsent:
          "Al enviar este formulario, usted acepta recibir comunicaciones de mercadeo.",
        phoneNumber: "Número de teléfono",
        phoneRequired: "El número de teléfono es obligatorio",
        propertyCounty: "Condado de la propiedad",
        propertyState: "Estado de la propiedad",
        stateRequired: "El estado es obligatorio",
        submit: "Acceda a las calculadoras hipotecarias",
      },
      mobileModal: {
        close: "Cerrar",
      },
      ourPartner: "NUESTRO SOCIO",
      profile: {
        address: "Dirección:",
        branchLicensePrefix: "Sucursal",
        companyLicensePrefix: "Compañía",
        contactPerson: "Contacte a {{name}}",
        directPhone: "Directo:",
        directPhoneAria: "Teléfono directo: {{phone}}",
        emailAria: "Correo electrónico: {{email}}",
        licensedIn: "Con licencia en {{states}}",
        mobilePhone: "Celular:",
        mobilePhoneAria: "Teléfono celular: {{phone}}",
        moreLicenses: "+{{count}} más",
        nmlsNumber: "NMLS #{{nmlsId}}",
        officePhone: "Oficina:",
        officePhoneAria: "Teléfono de oficina: {{phone}}",
      },
      share: {
        ariaLabel: "Comparta esta página",
        cancel: "Cancelar",
        closeModal: "Cerrar ventana",
        copied: "Copiado",
        copiedToClipboard: "¡Copiado al portapapeles!",
        copy: "Copiar",
        copyToClipboard: "Copiar al portapapeles",
        done: "Listo",
        emailBody:
          "Haga clic en este enlace para visitar la página de {{name}}: {{link}}",
        emailPlaceholder: "Correo electrónico",
        emailSubject: "Se ha compartido con usted la página de {{name}}",
        link: "Comparta esta página",
        modalTitle: "Comparta Esta Página",
        or: "O",
        send: "Enviar",
        shareViaEmail: "Comparta por correo electrónico",
        shareableLink: "Enlace para compartir",
      },
    },
    validation: {
      emailAddressInvalid: "Por favor ingrese un correo electrónico válido.",
      emailInUse:
        'Ya existe una cuenta con esa dirección de correo electrónico. Haz clic en "Iniciar Sesión" en su lugar.',
      emailMismatch:
        "Por favor, revise que las direcciones de correo electrónico coincidan.",
      emailRequired: "El correo electrónico es requerido",
      floifyAddress:
        "No puede usar una dirección de correo electrónico de floify.com. Por favor, use una dirección de correo electrónico diferente.",
      invalidEmail: "Correo electrónico no valido",
      invalidPassword: "Por favor ingresa una contraseña válida.",
      lenderAddress:
        "Este correo electrónico pertenece a un prestamista en Floify y no se puede reutilizar. Ingrese un correo electrónico diferente para continuar.",
      passwordRequired: "Por favor ingrese una contraseña.",
      termsRequired:
        "Por favor confirme que acepta los términos de Floify antes de continuar",
    },
  },
};
